import { useCallback, useState } from 'react';

const KEY = 'pd.sidebarCollapsed';

/** Desktop sidebar collapsed to icons, remembered per device. */
export function useSidebarCollapsed() {
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(KEY) === '1';
    } catch {
      return false;
    }
  });
  const toggle = useCallback(() => {
    setCollapsed((c) => {
      try {
        localStorage.setItem(KEY, c ? '0' : '1');
      } catch {
        /* private mode: still works for this visit */
      }
      return !c;
    });
  }, []);
  return { collapsed, toggle };
}
